export default __webpack_public_path__ + "static/media/dm.2ac8b434.svg";